import React from 'react'
import { features } from '../../constants'
import Card from '../Card/Card'

function Features() {
  return (
    <section id='layanan'>
      <div className="container text-center">
        <div className="row mb-5">
          <h2 className='mb-3'>Layanan Kami</h2>
          <h6 className='text-dark desc'>Kami berkomitmen untuk memberikan pelayanan terbaik untuk para pelanggan kami.</h6>
        </div>
        <div 
          className="d-flex justify-content-center justify-content-xl-between justify-content-xxl-between flex-wrap" 
          style={{rowGap: "25px", columnGap: "25px"}}
     
        >  
          {
            features.map(feature => {
              return(
                <Card icon={feature.icon} title={feature.title} content={feature.content} key={feature.id}/>
              )
            })
          }
        </div>
      </div>
    </section>
  )
}

export default Features